module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/logo1.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("淘金区域代理")]), _vm._v(" "), _c('ul', [_c('li', {
    class: {
      'active': _vm.addActive % 2 == 1
    }
  }, [_c('a', {
    attrs: {
      "href": "/reginalAgent/runnability"
    }
  }, [_vm._v("运行情况")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.addActive % 2 != 1
    }
  }, [_c('a', {
    attrs: {
      "href": "/reginalAgent/myService"
    }
  }, [_vm._v("我的客服")])])]), _vm._v(" "), _c('div', {
    staticClass: "logOut",
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("登出")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8eca63bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8eca63bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 258
// module chunks = 1